const Footer = () => {
  return (
    <footer className="bg-green-800 pt-16 pb-8 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-12">
          {/* Logo & Address */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 text-white mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-leaf-line text-2xl" />
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-xs font-semibold tracking-widest opacity-70">社会福祉法人</span>
                <span className="text-base font-bold tracking-wider">みどり苑</span>
              </div>
            </div>
            <address className="not-italic">
              <p className="text-green-200 text-xs mb-1">〒000-0000 ○○県○○市○○町1-2-3</p>
              <a href="tel:0120-000-000" className="text-white text-2xl font-bold tracking-wider block mt-3 hover:text-green-200 transition-colors">
                0120-000-000
              </a>
              <p className="text-green-300 text-xs mt-1">受付時間 9:00〜17:30（平日）</p>
            </address>
            <div className="flex gap-3 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors">
                <i className="ri-line-fill text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors">
                <i className="ri-instagram-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors">
                <i className="ri-facebook-circle-line text-lg" />
              </a>
            </div>
          </div>

          {/* Nav links */}
          <div>
            <p className="text-green-300 text-xs font-semibold tracking-widest mb-4">ページ内リンク</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "みどり苑について", href: "#about" },
                { label: "施設・サービス一覧", href: "#facility" },
                { label: "大切にしていること", href: "#important" },
                { label: "施設のようす", href: "#gallery" },
                { label: "採用情報", href: "#recruit" },
                { label: "お問い合わせ", href: "#contact" },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-green-100 text-sm hover:text-white transition-colors flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-green-400" />
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact CTA */}
          <div>
            <p className="text-green-300 text-xs font-semibold tracking-widest mb-4">お問い合わせ</p>
            <p className="text-green-100 text-sm leading-relaxed mb-6">
              施設見学・サービスのご相談など、お気軽にお問い合わせください。
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-white text-green-800 text-sm font-semibold px-6 py-3 rounded-lg hover:bg-green-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-line" />
              お問い合わせはこちら
            </a>

          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <small className="text-green-400 text-xs">&copy; 社会福祉法人 みどり苑 All Rights Reserved.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
